export default __webpack_public_path__ + "assets/exame-do-sul-component.b3eab7a8.svg";